module.exports = __webpack_public_path__ + "static/lipo-33cd577984e2f8f3af06f2fb09c830ff.png";